import { LOCALES } from "@marketplace/i18n";

export const appListI18n = {
    [LOCALES.ENG]: {
        table_header_name: 'Name',
        table_header_last_update: 'Last Update',
        table_header_status: 'Status',
        //table_header_ID_sandbox: 'Client ID - Sandbox',
        table_header_ID_prodaction: 'Client ID - Production',
        table_header_Secret_Expiry_Date: 'Secret Expiry Date',
        secret_expires_soon_hint: 'Secret Expires Soon \n\nTo prevent disruptions to your application, be sure to reset the Secret soon.',
        secret_expired_hint: 'Secret Expired \n\nYour App will not work as intended until the Secret is reset.'
    }
}
